import React from 'react'

export const FaqLink = ({
  href,
  children
}: {
  href: string
  children: React.ReactNode
}) => (
  /* eslint-disable-next-line @next/next/no-html-link-for-pages */
  <a className="text-orange-700" href={href}>
    {children}
  </a>
)

export { FaqLink as Link }
